import { render, staticRenderFns } from "./ActiveCarts.vue?vue&type=template&id=7ca0066d&scoped=true"
import script from "./ActiveCarts.vue?vue&type=script&lang=js"
export * from "./ActiveCarts.vue?vue&type=script&lang=js"
import style0 from "./ActiveCarts.vue?vue&type=style&index=0&id=7ca0066d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca0066d",
  null
  
)

export default component.exports